export const handleClasses = (
  target: Element | HTMLElement | null,
  classes: { add: string; remove: string }[],
) => {
  if (!target) return;

  for (const c of classes) {
    target.classList.add(c.add);
    target.classList.remove(c.remove);
  }
};

export const generateClasses = (
  add: boolean,
  addClasses: string,
  removeClasses: string,
) => {
  return [
    {
      add: add ? addClasses : removeClasses,
      remove: add ? removeClasses : addClasses,
    },
  ];
};
